import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import * as S from "./styles";

import { ProviderUserForm } from "components/Forms/Provider/ProviderUserForm";
import Button from "components/Button";

import { useProviderRegister } from "contexts/register/ProviderContext";
import { handleGuestProviderCreateSubmit } from "services/handles/ProviderHandles";

import { useRouterQuery } from "hooks/useRouterQuery";
import { useHistory } from "react-router-dom";
import { getTenantByCode } from "services/TenantServices";

import { ITenant } from "interfaces/Tenant";
import { fireToast } from "services/sweetAlertConfig";

const swal = Swal.mixin({});

export function ProviderRegister() {
  const query = useRouterQuery();
  const location = useHistory();

  const [tenant, setTenant] = useState<ITenant>();

  const { provider, user, errors, resetProvider } = useProviderRegister();

  const [isSending, setIsSending] = useState<boolean>(false);

  const hasErrors = Object.keys(errors).length > 0;

  const onCreateSuccess = () => {
    swal
      .fire({
        title: "Sucesso",
        text: "Seus dados foram enviados com sucesso! A central irá validá-los e a resposta será enviada para o e-mail registrado.",
        icon: "success",
        showConfirmButton: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      })
      .then((res) => {
        if (res.isConfirmed || res.isDismissed) {
          location.push("*");
        }
      });

    resetProvider();
  };

  const onCreateError = () => {
    fireToast("Ocorreu um erro ao enviar os seus dados para a central.");
  };

  async function handleSubmit() {
    if (!tenant) return;

    setIsSending(true);

//     await handleGuestProviderCreateSubmit({
//       name: provider.name,
//       password: user.password,
//       rg: user.rg,
//       cpf: user.cpf,
//       cnpj: user.cnpj,
//       managerName: provider.managerName,
//       tradingName: provider.tradingName,
//       email: user.email,
//       role: user.type ? user.type : 2,
//       tenantId: tenant.id,
// })
//       .then((res) => {
//         if (res.status === 201) onCreateSuccess();
//       })
//       .catch(onCreateError)
//       .finally(() => {
//         setIsSending(false);
//       });
  }

  async function findTenant() {
    const tenantCode = query.get("code");
    if (!tenantCode) {
      location.push("*");
      return;
    }

    const response = await getTenantByCode(tenantCode);
    if (response.status) {
      return setTenant(response.data);
    }

    location.push("*");
  }

  useEffect(() => {
    findTenant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.Wrapper>
      <section>
        <S.HelpHeader>
          <img src={tenant?.config.imgURL} alt="Logotipo da empresa" />
        </S.HelpHeader>

        <S.HelpContainer>
          <h1>Central {tenant?.name}</h1>
          <h2>Torne-se um prestador de serviço</h2>
          <p>
            Preencha o formulário ao lado e comece a fazer parte do time de
            prestadores de serviços associados da {tenant?.name}, trabalhando
            diariamente em ocorrências pronta-resposta.
          </p>
        </S.HelpContainer>
      </section>
      <section>
        <h2>Formulário de registro</h2>

        <S.WarningBadge>
          <span>
            Os dados inseridos serão revisados e poderão ser recusados se alguma
            inconsistência for encontrada. O retorno sobre a aprovação ou recusa
            será enviada no e-mail cadastrado.
          </span>
        </S.WarningBadge>

        <S.FormContainer>
          <ProviderUserForm />

          <Button
            disabled={isSending || hasErrors}
            type="button"
            onClick={handleSubmit}
            title="Enviar para a central"
          />
        </S.FormContainer>
      </section>
    </S.Wrapper>
  );
}
